<script lang="ts" setup>
import { Button } from '@brighterly/lib-lumee-ui'

import { useModalRetrySuccess } from './modal-retry-success.hook'
import bg from './bg-success.png'

defineOptions({
  name: 'ModalRetrySuccess',
})

const AppModal = defineAsyncComponent(() => import('@shared/ui/modals').then((module) => module.AppModal))

const {
  title,
  btnText,
  setSubmit,
  setClose,
} = useModalRetrySuccess()
</script>

<template>
  <AppModal
    @close="setClose"
  >
    <template #topSlot>
      <div class="rs__hero">
        <img
          :src="bg"
          alt="success illustration"
        >
      </div>
    </template>
    <template #contentSlot>
      <div class="rs">
        <div class="rs__info">
          <h5 class="rs__title-xl btly-text-title-xl">
            {{ title }}
          </h5>
          <div class="rs__body-xl btly-text-body-xl">
            Your payment was processed, and your subscription has been renewed
          </div>
        </div>
      </div>
    </template>
    <template #bottomSlot>
      <Button
        :text="btnText"
        fill
        @click="setSubmit"
      />
    </template>
  </AppModal>
</template>

<style scoped lang="scss" src="./ModalRetrySuccess.scss" />
